// extracted by mini-css-extract-plugin
export var chatHtmlText = "_nq-2";
export var chatLink = "_nq-0";
export var chatText = "_nq-1";